import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  identity: {
    cifConcession: '',
    vehicleId: '',
    vin: ''
  },
  subMenuTabSelected: null,
  componentsCMS: null,
  legalConditions: null,
  filtersHasChanged: false,
  dateCheck: new Date().toISOString(),
  identityData: {
    idCliente: null,
    plate: null,
    idStoragePark: null
  },
  checkTransferFilters: {
    idStoragePark: null,
    idProvider: null,
    dateCheck: new Date().toISOString(),
    idTransport: null,
    plate: null
  },
  acts: null,
  act: null,
  transferActs: null,
  transferAct: null,
  risk: {},
  errorIdentity: null,
  checklistAccessories: [],
  checklistsExternalBreaks: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
